import {FC, Suspense} from 'react'
import TopBarProgress from 'react-topbar-progress-indicator'

import {WithChildren} from '_metronic/helpers'

import Spinner from './Spinner'

const SuspensedView: FC<WithChildren> = ({children}) => {
  return (
    <Suspense
      fallback={
        <>
          <TopBarProgress />
          <div
            className='d-flex align-items-center justify-content-center h-100 w-100'
            style={{minHeight: 'calc(100svh - 500px)'}}
          >
            <Spinner color='primary' />
          </div>
        </>
      }
    >
      {children}
    </Suspense>
  )
}

export default SuspensedView
